import type { SVGProps } from "react";
export default function ArrowLeftSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      className="flex shrink-0 grow-0"
      {...props}
    >
      <g id="Icon">
        <path
          id="Icon_2"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.8}
          d="M19 12H5m0 0 7 7m-7-7 7-7"
        />
      </g>
    </svg>
  );
}
